import { render, staticRenderFns } from "./editToMenu.vue?vue&type=template&id=05a157e8"
import script from "./editToMenu.vue?vue&type=script&lang=js"
export * from "./editToMenu.vue?vue&type=script&lang=js"
import style0 from "./editToMenu.vue?vue&type=style&index=0&id=05a157e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports